import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isVendorSidebarCollapsed, setIsVendorSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('vendorSidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const [isAdminSidebarCollapsed, setIsAdminSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('adminSidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  
  // Mobile sidebar states
  const [isVendorMobileSidebarOpen, setIsVendorMobileSidebarOpen] = useState(false);
  const [isAdminMobileSidebarOpen, setIsAdminMobileSidebarOpen] = useState(false);
  const [isVendorMobileSidebarCollapsed, setIsVendorMobileSidebarCollapsed] = useState(false);
  const [isAdminMobileSidebarCollapsed, setIsAdminMobileSidebarCollapsed] = useState(false);

  const toggleVendorSidebar = () => {
    const newState = !isVendorSidebarCollapsed;
    setIsVendorSidebarCollapsed(newState);
    localStorage.setItem('vendorSidebarCollapsed', JSON.stringify(newState));
  };

  const toggleAdminSidebar = () => {
    const newState = !isAdminSidebarCollapsed;
    setIsAdminSidebarCollapsed(newState);
    localStorage.setItem('adminSidebarCollapsed', JSON.stringify(newState));
  };

  // Mobile sidebar toggle functions
  const toggleVendorMobileSidebar = () => {
    if (!isVendorMobileSidebarOpen) {
      // If sidebar is closed, open it in expanded state
      setIsVendorMobileSidebarOpen(true);
      setIsVendorMobileSidebarCollapsed(false);
    } else {
      // If sidebar is open, toggle collapsed state
      setIsVendorMobileSidebarCollapsed(!isVendorMobileSidebarCollapsed);
    }
  };

  const toggleAdminMobileSidebar = () => {
    if (!isAdminMobileSidebarOpen) {
      // If sidebar is closed, open it in expanded state
      setIsAdminMobileSidebarOpen(true);
      setIsAdminMobileSidebarCollapsed(false);
    } else {
      // If sidebar is open, toggle collapsed state
      setIsAdminMobileSidebarCollapsed(!isAdminMobileSidebarCollapsed);
    }
  };

  // Close mobile sidebar functions
  const closeVendorMobileSidebar = () => {
    setIsVendorMobileSidebarOpen(false);
    setIsVendorMobileSidebarCollapsed(false); // Reset to expanded state for next open
  };

  const closeAdminMobileSidebar = () => {
    setIsAdminMobileSidebarOpen(false);
    setIsAdminMobileSidebarCollapsed(false); // Reset to expanded state for next open
  };

  const value = {
    isVendorSidebarCollapsed,
    isAdminSidebarCollapsed,
    isVendorMobileSidebarOpen,
    isAdminMobileSidebarOpen,
    isVendorMobileSidebarCollapsed,
    isAdminMobileSidebarCollapsed,
    toggleVendorSidebar,
    toggleAdminSidebar,
    toggleVendorMobileSidebar,
    toggleAdminMobileSidebar,
    closeVendorMobileSidebar,
    closeAdminMobileSidebar,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
